import { createContext, Provider, useContext } from 'react';
import { MarketLocation } from '../use-market-location/use-market-location';

const context = createContext<MarketLocation | null>(null);

export const MarketLocationProvider = context.Provider as Provider<MarketLocation>;

export function useCurrentMarketLocation(): MarketLocation {
  const marketLocation = useContext(context);
  if (!marketLocation) {
    throw new Error('Call to "useMarketLocation" was not wrapped inside "MarketLocationProvider"');
  }
  return marketLocation;
}
